const REPORT_ACTIONS = [
  { label: "No action" },
  { label: "Warning" },
  { days: 7, label: "7 days" },
  { days: 14, label: "14 days" },
  { permanent: true as const, label: "Permanent" },
] as const;

export type ReportActionIndex = 0 | 1 | 2 | 3 | 4;

export function isPermanentReportAction(index: ReportActionIndex) {
  return index === 4;
}

export function reportActionLabel(index: ReportActionIndex) {
  return REPORT_ACTIONS[index].label;
}

export function reportActionDays(index: ReportActionIndex) {
  const action = REPORT_ACTIONS[index];
  return "days" in action ? action.days : null;
}

export function ModerationReportActionPicker({
  value,
  onChange,
}: {
  value: ReportActionIndex;
  onChange: (value: ReportActionIndex) => void;
}) {
  const selected = REPORT_ACTIONS[value];
  const isPermanent = isPermanentReportAction(value);

  return (
    <div className="moderation-report-action-picker">
      <p className="moderation-report-action-picker-label">Action</p>
      <div className="moderation-action-chips" role="radiogroup" aria-label="Report action">
        {REPORT_ACTIONS.map((action, index) => {
          const actionIsPermanent = index === 4;
          const isActive = index === value;
          return (
            <button
              key={action.label}
              type="button"
              role="radio"
              aria-checked={isActive}
              className={[
                "moderation-action-chip",
                isActive ? "selected" : "",
                actionIsPermanent ? "is-permanent" : "",
              ].filter(Boolean).join(" ")}
              onClick={() => onChange(index as ReportActionIndex)}
            >
              {action.label}
            </button>
          );
        })}
      </div>

      <p className={`moderation-report-action-hint${isPermanent ? " moderation-report-action-hint--danger" : ""}`}>
        {value === 0
          ? "Close the report without taking action against the reported member."
          : value === 1
            ? "Send a formal warning. Further issues may lead to suspension."
            : isPermanent
              ? "Permanently remove this member from matching."
              : `Temporarily pause matching access for ${selected.label}.`}
      </p>
    </div>
  );
}
